<!-- No tags present, single column format.  Currently the data structure relies on first filter grouping in a multi-column format being in the right column.  -->
<div class="filter_content single_column {{place}}" *ngIf="filterGroupings && filterGroupings.length && !filterGroupings[0].rightColumn">
  <ng-container [ngTemplateOutlet]="metaGrouping" [ngTemplateOutletContext]="{ filterGroupings: filterGroupings }"></ng-container>
</div>

<div class="filter_content multi_column {{place}}" *ngIf="filterGroupings && filterGroupings.length && filterGroupings[0].rightColumn">
  <div class = "column left-column">
    <ng-container [ngTemplateOutlet]="metaGrouping" [ngTemplateOutletContext]="{ filterGroupings: filterGroupings | filterListByTruthyProp:'rightColumn':true }" ></ng-container>
  </div>
  <div class="column right-column">
    <div class="search_bar">
      <icon matIcon="search"></icon>
      <input #searchInput (keyup)="searchAction$.next($event.target['value'])"/>
      <icon class="close" *ngIf="searchInput.value" (click)="searchAction$.next(''); searchInput.value = ''" matIcon="close"></icon>
    </div>
    <ng-container [ngTemplateOutlet]="metaGrouping" [ngTemplateOutletContext]="{ filterGroupings: filterGroupings | filterListByTruthyProp:'rightColumn', noBreaks: true }" ></ng-container>
  </div>
</div>



<ng-template #metaGrouping let-filterGroupings="filterGroupings" let-noBreaks="noBreaks">
  <ng-container *ngFor="let filtersGrouping of filterGroupings; trackBy: trackByGrouping;">
    <div class="group_content" [ngClass]="filterPage + (noBreaks ? ' noBreaks' : '')">
      <div *ngIf="!!filtersGrouping.title" [ngClass]="{ title2: filterPage !== filterPageTypes.home, mainPageTitle: filterPage === filterPageTypes.home }" (click)="expandedStates[filtersGrouping.title] = expandedStates[filtersGrouping.title] === 'collapse' ? 'expand' : 'collapse'">
          <icon class="arrow" [matIcon]="(expandedStates[filtersGrouping.title] === 'collapse' ? 'arrow_right' : 'arrow_drop_down')"></icon>{{ filtersGrouping.title }}
      </div>
      <div class="drop" [ngClass]="expandedStates[filtersGrouping.title]" [@drop]="expandedStates[filtersGrouping.title]">
        <div class="no-label hideTitle" *ngIf="!!filtersGrouping.emptyMessage">{{ filtersGrouping.emptyMessage }}</div>
        <ng-container [ngTemplateOutlet]="filtersGroupTemplate" [ngTemplateOutletContext]="{filtersGrouping: filtersGrouping, noBreaks: noBreaks }"></ng-container>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #filtersGroupTemplate let-filtersGrouping="filtersGrouping" let-noBreaks="noBreaks">
  <ng-container *ngFor="let filtersGroup of filtersGrouping.filterGroups; trackBy: trackByGroup">
    <div [class]="'title3 ' + filtersGroup.groupId" *ngIf="!!filtersGroup.title && !filtersGroup.hideTitle">{{ filtersGroup.title }}</div>
    <div [class]="'no-label' + (filtersGroup.hideTitle ? ' hideTitle' : '')" *ngIf="!filtersGroup.filters.length && (!!filtersGroup.title)">No {{ filtersGroup.title || filtersGroup.groupId | lowercase }}</div>
    <div [class]="'items ' + filtersGroup.groupId" *ngIf="!!filtersGroup && !!filtersGroup.filters" >
      <ng-container *ngFor="let filter of filtersGroup.filters; trackBy: trackByFilter">
        <ng-container *ngIf="!filter.hidden">
          <div class="nested-labels-holder" *ngIf="filter.type === fUITypes.NestedLabelGroup">
            <div [title]="filter.showTitle && filter.name ? filter.name : null" (click)="toggleFilter(filter)" class="item smooth" [ngClass]="{selected: filter.selected, disabled: filter.disabled }">
                <photo [data]="filter.photoData"></photo>
                <div class="name">{{ filter.name }}</div>
                <div style="flex:1"></div>
                <icon class="check" [ngClass]="{selected: true, invisible: !filter.selected}" icon="tick_24px"></icon>
              <div class="chevron" (click)="toggleNestedFilter($event, filter)" *ngIf="!!filter.children.length">
                <icon class="expand" [ngClass]="{expanded: nestedHolderStates[filter.id] === 'expand'}" icon="expand_18px"></icon>
              </div>
              <div class="bg smooth"></div>
            </div>

            <!-- currently nested children can only be colored labels -->
            <div class="nested-labels" *ngIf="!!filter.children.length" [@dropMenu]="nestedHolderStates[filter.id] ? nestedHolderStates[filter.id] : 'collapse' ">
              <label-toggle-bar *ngFor="let nestedFilter of filter.children; trackBy: trackByIndex"
                (toggleLabel)="toggleFilter(nestedFilter)"
                [text]="nestedFilter.name"
                [color]="nestedFilter.color"
                [nested]="true"
                [selected]="nestedFilter.selected"
                [disabled]="nestedFilter.disabled"
              ></label-toggle-bar>
            </div>
          </div>
          <photo-toggle-card *ngIf="filter.type === fUITypes.PhotoLabel"
            (click)="toggleFilter(filter)"
            [showTitle]="filter.showTitle"
            [photoData]="filter.photoData"
            [name]="filter.name"
            [selected]="filter.selected"
            [disabled]="filter.disabled"
          ></photo-toggle-card>
          <toggle-button *ngIf="filter.type === fUITypes.Asset"
            [selected]="filter.selected"
            [enabled]="filter.disabled"
            (select)="toggleFilter(filter)"
          >
          <asset-card  [asset]="filter.asset"></asset-card> 
          </toggle-button>
          <div class="program" *ngIf="filter.type === fUITypes.Checkbox" [ngClass]="{ disabled: filter.disabled && !filter.selected}">
            <mat-checkbox (change)="toggleFilter(filter)" [checked]="filter.selected" [disabled]="filter.disabled && !filter.selected" color="primary">
              <div class="name">{{ filter.name ? filter.name : 'Unnamed schedule' }}</div>
            </mat-checkbox>
          </div>
          <div class="program subCheckbox" *ngIf="filter.type === fUITypes.SubCheckbox" [ngClass]="{ disabled: filter.disabled && !filter.selected }">
            <icon class="sub-icon" icon="SUBICON"></icon>
            <mat-checkbox (change)="toggleFilter(filter)" [checked]="filter.selected" [disabled]="filter.disabled && !filter.selected"  color="primary">
              <div class="name">{{ filter.isDate ? (filter.name | date: "EEEE d LLLL") : filter.name ? filter.name : 'Unnamed schedule' }}</div>
            </mat-checkbox>
          </div>
          <label-toggle-bar *ngIf="filter.type === fUITypes.ColoredLabel"
            (toggleLabel)="toggleFilter(filter)"
            [text]="filter.name"
            [color]="filter.color"
            [selected]="filter.selected"
            [disabled]="filter.disabled"
          ></label-toggle-bar>
          <div *ngIf="filter.type === fUITypes.Icon && (filtersGroup.title !== 'groups tagged' || workforceGroupsById[filter.name])" class="item smooth" [ngClass]="{selected: filter.selected, disabled: filter.disabled }" (click)="toggleFilter(filter)">
            <div class="{{ filter.matIconName }} icon">
              <icon class="retain_color" [icon]="filter.matIconName"></icon>
            </div>
            <div class="name">{{ workforceGroupsById[filter.name] ? workforceGroupsById[filter.name].realName : filter.name }}</div>
            <div style="flex:1"></div>
            <icon class="check" [ngClass]="{selected: true, invisible: !filter.selected}" icon="tick_24px"></icon>
            <div class="bg smooth"></div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
</ng-template>
